import { useEffect, useRef, useState } from 'react';

/**
 * `true` в течение короткого времени после того, как значение изменилось.
 *
 * Нужно из-за фонового обновления: данные приезжают молча и подменяются в
 * один кадр. Без отметки человек либо не заметит, что цифра стала другой,
 * либо решит, что ошибся при чтении. Первый показ подсветкой не считается —
 * там меняется не значение, а пустота на значение.
 */
export function useValueChanged(value: unknown, holdMs = 1500): boolean {
  const previous = useRef(value);
  const [changed, setChanged] = useState(false);

  useEffect(() => {
    if (Object.is(previous.current, value)) return;
    previous.current = value;
    setChanged(true);

    const timer = setTimeout(() => setChanged(false), holdMs);
    return () => clearTimeout(timer);
  }, [value, holdMs]);

  return changed;
}
